/*-----------------------------------------------------------------------------------
 * Kingsoft Office Enterprise Cloud Services.
 * Copyright (c) Kingsoft Office,All rights reserved.
 *-----------------------------------------------------------------------------------*/
import Cookie from 'js-cookie'
export const getOpenWay = () => {
  return Cookie.get('OpenWay')
}
export const setOpenWay = value => {
  Cookie.set('OpenWay', value)
}
// orderid start
export const setOrderId = value => {
  Cookie.set('OrderId', value)
}
export const getOrderId = () => {
  return Cookie.get('OrderId')
}
export const removeOrderId = () => {
  Cookie.remove('OrderId')
}
export const getCsrf = () => {
  var csrftoken = Cookie.get('csrf') || ''
  if (!csrftoken) {
    var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
    var maxPos = $chars.length
    for (var i = 0; i < 32; i++) {
      csrftoken += $chars.charAt(Math.floor(Math.random() * maxPos))
    }
    Cookie.set('csrf', csrftoken, { domain: 'wps.cn', path: '/' })
  }
  return csrftoken
}

export const getNewPCVersionStatus = () =>
  Cookie.get('wpsoffice_hyperion') === 'true'
// orderid end
